class DiscountsController extends HTMLElement {
    constructor() {
      super();
  
      this.successMessage = this.getAttribute("data-success-message");
      this.errorMessage = this.getAttribute("data-error-message");
  
      this.customerId = this.getAttribute("data-customer-id");
      this.urlParameter = this.getAttribute("data-url-parameter");
      this.discountsApplied = this.getAttribute("data-discounts-applied");
  
      this.init();
    }
  
    init() {
      // // Check url for matching parameter
      // const urlParams = new URLSearchParams(window.location.search);
      // const urlParameter = urlParams.get(this.urlParameter);
      // if (urlParameter && urlParameter.length > 0) {
      //   this.applyDiscount(urlParameter);
      // } else {
      //   // Check discount code in local storage
      //   const codeData = this.getLocalStorageCupom();
      //   if (codeData && codeData.redirect) {
      //     // set redirect to false
      //     this.setLocalStorageCupom(
      //       codeData.code,
      //       codeData.redirectUrl,
      //       false,
      //       codeData.validated,
      //       codeData.isValid,
      //       codeData.message,
      //     );
      //     this.redirectToUrl(codeData.redirectUrl);
      //   }
      // }
      // this.checkCouponsValidation();

      const discountCodeCookie = document.cookie.split("; ").find((row) => row.startsWith("discount_code="));
      if (discountCodeCookie) {
        const discountCode = discountCodeCookie.split("=")[1];
        console.log("Initializing DiscountsController with discount_code:", discountCode);
        this.validateDiscountCode(discountCode);
      } else {
        localStorage.removeItem("dorel:discounts:code");
        document.dispatchEvent(new CustomEvent("dorel:discounts:removed"));
      }
  
    }
  
    checkCouponsValidation() {
      if (this.discountsApplied && this.discountsApplied !== "") {
        const firstCoupon = this.discountsApplied.split(",")[0];
        this.validateDiscountCode(firstCoupon);
        return;
      }
      const codeData = this.getLocalStorageCupom();
      if (!codeData) return;
      if (!codeData.validated) {
        this.validateDiscountCode(codeData.code);
      }
    }
  
    redirectToUrl(url) {
      // Redirect if current url is not the redirect url
      if (window.location.href !== url) {
        window.location.href = url;
      }
    }
  
    applyDiscount(code) {
      // Make redirect url without this.urlParameter
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete(this.urlParameter);
  
      const redirectUrl = `https://${window.location.host}${window.location.pathname}${urlParams.size ? "?" : ""}${urlParams.toString()}`;
      this.setLocalStorageCupom(code, redirectUrl, true, false, false, null);
  
      window.location.href = `https://${window.location.host}/discount/${code}`;
    }
  
    getCart(callback) {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
          callback(data);
        });
    }
  
    validateDiscountCodeRequest(code, cart) {
      const url = `https://javardo-backend-production-f7c67937b296.herokuapp.com/discounts/api/validate-discount-code/dorel-cosco-kids.myshopify.com`;
      const body = {
        code,
        cart,
        customer: this.customerId ? { id: this.customerId } : null,
      };
  
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          let message = null;
          if (data.valid) {
            message = this.successMessage;
            this.setLocalStorageCupom(code, null, false, true, true, message, data);
          } else {
            if (data.warnings && data.warnings.length > 0) {
              message = data.warnings[0].message;
            } else {
              message = this.errorMessage;
            }
            this.setLocalStorageCupom(code, null, false, true, false, message);
          }
  
          document.dispatchEvent(new CustomEvent("dorel:discounts:validated", { detail: { data, code } }));
  
          // Add custom discount rules to cart attributes
          if (data.custom_rules && data.custom_rules.length > 0) {
            const customRules = [];
            data.custom_rules.map((rule) => {
              customRules.push({
                target: rule.target,
                value: rule.value,
                value_type: rule.value_type,
              });
            });
            const cartAttributes = {
              __extra_discount_rules: customRules,
            };
  
            fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                attributes: cartAttributes,
              }),
            })
              .then((response) => response.json())
              .then((data) => {});
          }
        });
    }
  
    validateDiscountCode(code) {
      // this.getCart((cart) => {
      //   this.validateDiscountCodeRequest(code, cart);
      // });

      let amount = 20;
      
      if (window.location.host.includes("funcionarios")) {
        const codeAmount = code.match(/[A-Za-z]+(\d+)$/);
        if (codeAmount) {
          amount = 20
        } else {
          amount = 30;
        }
      } else if (window.location.host.includes("babyoutlet")) {
        amount = 20;
      } else {
        // Else, extract amount from code for other cases than "funcionarios" or "babyoutlet"
        const amountMatch = code.match(/[A-Za-z]+(\d+)$/);
        if (amountMatch) {
          amount = parseInt(amountMatch[1], 10);
        } else {
          console.warn("Invalid discount code format. Expected format like 'CODE20' or 'CODE25'.");
        }
      }
      
      // Extract amount from code like "20" or "25" inside the string "CODE20" or "CODE25"
      // Match examples:
      // "CODE20" → captura 20
      // "PROMO25" → captura 25
      // "DESCONTO30" → captura 30
      // "abc123" → captura 123
      // "OFF50" → captura 50
      // "funcionarios40" → captura 40
      // NOT Match examples:
      // "@carlos.oliveira"
      // "CODE20OFF"
      // "20CODE"
      // "PROMO25%"
      // "@PROMO25"

      this.setLocalStorageCupom(code, null, false, true, true, "Discount settings extracted from code.", {
        valid: true,
        warnings: [],
        discount: {
          allocation_method: "across",
          target_selection: "all",
          target_type: "line_item",
          value: amount * -1,
          value_type: "percentage",
          allocation_limit: null,
          entitled_product_ids: [],
          entitled_variant_ids: [],
        },
        custom_rules: [],
      });
  
      document.dispatchEvent(
        new CustomEvent("dorel:discounts:validated", {
          detail: {
            data: {
              valid: true,
              warnings: [],
              discount: {
                allocation_method: "across",
                target_selection: "all",
                target_type: "line_item",
                value: amount * -1,
                value_type: "percentage",
                allocation_limit: null,
                entitled_product_ids: [],
                entitled_variant_ids: [],
              },
              custom_rules: [],
            },
            code: code,
          },
        })
      );

    }
  
    clearDiscount() {
      localStorage.removeItem("dorel:discounts:code");
      document.dispatchEvent(new CustomEvent("dorel:discounts:removed"));
  
      // Clear cart attributes
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            __extra_discount_rules: null,
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.redirectToUrl(`https://${window.location.host}/discount/CLEAR`);
        });
    }
  
    // Local storage
    setLocalStorageCupom(code, redirectUrl, redirect, validated, isValid, message, data) {
      localStorage.setItem(
        "dorel:discounts:code",
        JSON.stringify({
          code,
          redirectUrl,
          redirect,
          validated,
          isValid,
          message,
          data,
        }),
      );
    }
  
    getLocalStorageCupom() {
      const data = localStorage.getItem("dorel:discounts:code");
      return data ? JSON.parse(data) : null;
    }
  }
  
  if (!customElements.get("discounts-controller")) {
    customElements.define("discounts-controller", DiscountsController);
  }
  
  // CartDiscounts
  class CartDiscounts extends DiscountsController {
    constructor() {
      super();
  
      this.cupomInput = this.querySelector(`input[name="cupom"]`);
      this.applyBtn = this.querySelector(".cart-discounts__apply-btn");
      this.warningWrapper = this.querySelector(".warning");
      this.warningMessage = this.warningWrapper.querySelector("p");
  
      this.init();
    }
  
    init() {
      if (!this.cupomInput || !this.applyBtn) {
        return;
      }
  
      this.applyBtn.addEventListener("click", this.handleApplyDiscount.bind(this));
      document.addEventListener("dorel:discounts:validated", this.populateDiscountCode.bind(this));
  
      this.populateDiscountCode();
    }
  
    populateDiscountCode() {
      // Get discount code on DiscountApplication
      const appliedCoupon = this.getLocalStorageCupom();
      if (appliedCoupon && appliedCoupon.validated) {
        this.cupomInput.value = appliedCoupon.code;
        if (appliedCoupon.message) {
          this.showWarningMessage(appliedCoupon.message, appliedCoupon.isValid ? "valid" : "invalid");
        }
      }
    }
  
    handleApplyDiscount(event) {
      event.preventDefault();
      const code = this.cupomInput.value;
  
      if (code !== "") {
        this.applyDiscount(code);
      } else {
        this.clearDiscount();
        this.hideWarningMessage();
      }
    }
  
    showWarningMessage(message, status) {
      this.warningMessage.innerHTML = message;
      this.warningWrapper.style.display = "flex";
  
      if (status === "valid") {
        this.warningWrapper.classList.add("valid");
        this.warningWrapper.classList.remove("invalid");
      } else {
        this.warningWrapper.classList.add("invalid");
        this.warningWrapper.classList.remove("valid");
      }
    }
  
    hideWarningMessage() {
      this.warningMessage.innerHTML = "";
      this.warningWrapper.style.display = "none";
      this.warningWrapper.classList.remove("valid");
      this.warningWrapper.classList.remove("invalid");
    }
  }
  
  if (!customElements.get("cart-discounts")) {
    customElements.define("cart-discounts", CartDiscounts);
  }  